import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSmartList } from "../../toolympus/hooks/useSmartList"
import { useSpace } from "../Spaces/SpaceContext";
import { Contact, ContactSchema } from "./types"
import { apiFetch } from "../../toolympus/api/core";
import { useEditRecordAttribute } from "../Projects/useEditProjectAttribute";
import { useItemActionWithConfirmation } from "../../toolympus/api/useAction";

export const useContactsList = () => {
  const { spaceId } = useSpace();
  const apiPathBase = spaceId ? `/api/s/${spaceId}/crm/contact` : "";


  const [tags,setTags] = useState<string[]>([]);
  const history = useHistory();
  
  useEffect(() => {
    const search = new URLSearchParams(window.location.search);
    const fromSearch = (search.get("tags") || "").split(",").map(s => s.trim()).filter(x => !!x);
    if(fromSearch.length) {
      setTags(fromSearch);
    }
  }, []);

  useEffect(() => {
    const search = new URLSearchParams(window.location.search);
    if(tags.length) {
      search.set("tags", tags.join(","));
    } else {
      search.delete("tags");
    }
    history.replace({ pathname: window.location.pathname, search: search.toString() });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tags]);


  const data = useSmartList<Contact>(
    apiPathBase, {
      newRecordDefault: { name: "" } as any,
      schema: ContactSchema,
      noLoad: !apiPathBase,
      noCount: true,
      getRecordApiPath: r => `${apiPathBase}/${r._id}`,
      extraParams: {
        ...(tags.length ? { tags } : {}),
      },
      skipTextFilter: true,
      textFilterApi: {
        paramName: "search",
      },
    },
  );

  const updateContact = (id: string, changes: Partial<Contact>) => {
    if(!id || !spaceId) {
      return Promise.resolve({ _id: id} as Contact);
    } 
    return apiFetch<Contact>(`${apiPathBase}/${id}`, "put", changes)
      .then(updated => {
        data.setData(contacts => contacts.map(c => c._id === updated._id ? { ...c, ...updated } : c));
        return updated;
      });
  }

  const removeContact = useItemActionWithConfirmation<Contact, {}>(
    async (item) => {
      await apiFetch<{}>(`${apiPathBase}/${item._id}`, "delete");
      data.setData(contacts => contacts.filter(x => x._id !== item._id));
      if(data.editRecord.item?._id === item._id) {
        data.editRecord.cancel();
      }
      return {};
    }, {
      title: "Удалить контакт",
      confirmationLabel: "удалить",
      memoTrigger: `${apiPathBase}${data.editRecord.item?._id}`,
    });

  const editAttributes = useEditRecordAttribute(updateContact);

  return {
    ...data,

    updateContact,
    editAttributes,

    removeContact,

    tags,
    setTags,

  }
}


export type ContactsListData = ReturnType<typeof useContactsList>;
